import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete"; // Import the Delete icon
import { IMAGE_BASE_URL } from "../../config/constants";
import QuantitySelector from "./../../utility-v1/QuantitySelector";
import { FONT_FAMILY } from "../../config/themeConstants"; // Import FONT_FAMILY
import { useMediaQuery } from "@mui/material";

export default function CartCard({
  image,
  label,
  price,
  boxno,
  quantity,
  itemLeft,
  handleRemove,
  updateParent,
  callingPage,
}) {
  const [currentQuantity, setCurrentQuantity] = useState(quantity);
  const [itemTotal, setItemTotal] = useState(parseFloat(price) * quantity);

  useEffect(() => {
    handleQuantityChange(quantity);
  }, [quantity]);

  // Update the total when quantity changes
  const handleQuantityChange = (newQuantity) => {
    setCurrentQuantity(newQuantity);
    const newTotal = parseFloat(price) * newQuantity;
    setItemTotal(newTotal);
    updateParent(newQuantity); // Send updated quantity to parent
  };
  const TruncateTitle = ({ title }) => {
    const isMobile = useMediaQuery("(max-width:600px)"); // Check if the screen width is 600px or less

    // Determine the truncation length
    const truncationLength = isMobile ? 30 : 50;

    // Truncate the title based on the truncation length
    const truncatedTitle =
      title.length > truncationLength
        ? `${title.substring(0, truncationLength)}...`
        : title;

    return truncatedTitle;
  };

  return (
    <Box
      sx={{
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        padding: 1,
        marginBottom: 1,
        backgroundColor: "#f9f9f9",
      }}
    >
      <Grid container spacing={2}>
        {/* Image section with responsive size */}
        <Grid item xs={3} md={3}>
          <CardMedia
            component="img"
            sx={{
              width: { xs: "80px", lg: "100px" }, // Responsive width
              height: { xs: "120px", lg: "150px" }, // Responsive height
              borderRadius: "8px",
              fontFamily: FONT_FAMILY,
              fontSize: "12px",
            }}
            image={IMAGE_BASE_URL + image}
            alt={label}
          />
        </Grid>

        {/* Product details */}
        <Grid item xs={9} md={9} container spacing={1}>
          {/* Label spanning 3 columns */}
          <Grid item xs={12}>
            <Typography
              sx={{
                fontFamily: FONT_FAMILY,
                fontSize: { xs: "16px", lg: "18px" },
                fontWeight: "500",
                color: "teal", // Optional: Use theme primary color for Total
              }}
            >
              <TruncateTitle title={label} />
            </Typography>
          </Grid>

          {/* Price and Quantity */}
          <Grid item xs={9}>
            {callingPage === "Checkout" ? (
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: "15px" ,fontWeight: "500",}}>
                Quantity: {currentQuantity}
              </Typography>
            ) : (
              <QuantitySelector
                initialQuantity={parseInt(currentQuantity)}
                minQuantity={1}
                maxQuantity={itemLeft}
                onQuantityChange={handleQuantityChange}
              />
            )}
          </Grid>

          <Grid
            item
            xs={3}
            sx={{
              textAlign: "right", // Align text to the right
            }}
          >
            {callingPage !== "Checkout" && (
              <IconButton
                onClick={handleRemove}
                sx={{
                  color: "#000", // Use a color that contrasts with the background
                }}
              >
                <DeleteIcon
                  sx={{
                    fontSize: { xs: 17, lg: 24 }, // Responsive font size for different devices
                  }}
                />
              </IconButton>
            )}
          </Grid>

          <Grid item xs={8}>
            <Typography
              sx={{
                fontFamily: FONT_FAMILY,
                fontSize: { xs: "16px", lg: "22px" },
              }}
            >
              Price: ₹{parseFloat(price).toFixed(2)}
            </Typography>
          </Grid>
          {callingPage !== "Checkout" && (<Grid item xs={4}>
            <Typography
              sx={{
                fontFamily: FONT_FAMILY,
                fontSize: { xs: "14px", lg: "20px" },
                textAlign: "right", // Align text to the right
                color: "blue",
              }}
            >
              {`${itemLeft} left`}
            </Typography>
          </Grid>  )}

          {/* Total Price */}
          <Grid item xs={12} sx={{ textAlign: { xs: "right", sm: "right" } }}>
            <Typography
              sx={{
                fontFamily: FONT_FAMILY,
                fontSize: { xs: "13px", lg: "20px" }
              }}
            >
              <Typography
                component="span"
                sx={{
                  fontFamily: FONT_FAMILY,
                  fontWeight: "500", // Highlight Total text
                  fontSize: { xs: "17px", lg: "24px" },
                  color: "teal", // Optional: Use theme primary color for Total
                }}
              >
                ₹{itemTotal.toFixed(2)}
              </Typography>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
